import styled from 'styled-components';
import COLORS from 'shared/constants/colors';
import { Link as ReactRouterLink } from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

const Title = styled.h2`
  font-size: 24px;
  font-weight: 100;
  margin: 0;
`;
const Container = styled.div`
  background-color: ${COLORS.WHITE};
  padding: 15px;
  margin: 15px 0;
`;

const Link = styled(ReactRouterLink)`
  text-decoration: none;
  color: inherit;
  font-size: 13px;
`;
const CurrentPageTitle = styled.p`
  color: ${COLORS.BLACK};
  font-weight: 700;
  font-size: 13px;
`;

const Breadcrumb = styled(Breadcrumbs)`
  line-height: 0 !important;
`;
export { Container, Title, Breadcrumb, Link, CurrentPageTitle };
